// A collection of DOM helper functions

/**
 * Query a single element
 * @param {String} selector - The CSS selector to query.
 * @param {HTMLElement|Document} [parent=document] - The parent to query within.
 * @returns {HTMLElement|null}
 */
export const qs = (selector, parent = document) => parent.querySelector(selector);

/**
 * Query multiple elements
 * @param {String} selector - The CSS selector to query.
 * @param {HTMLElement|Document} [parent=document] - The parent to query within.
 * @returns {NodeList}
 */
export const qsAll = (selector, parent = document) => parent.querySelectorAll(selector);

/**
 * Attaches an event listener to an element if it exists.
 * @param {HTMLElement} element - The element to attach the event to.
 * @param {String} event - The event name (e.g., 'click').
 * @param {Function} handler - The event handler function.
 * @param {Object} [options] - Additional options for addEventListener.
 */
export const on = (element, event, handler, options) => {
  if (element) {
    element.addEventListener(event, handler, options);
  }
};

/**
 * Creates a debounced version of a function.
 * @param {Function} func - The function to debounce.
 * @param {Number} delay - The delay in milliseconds.
 * @returns {Function}
 */
export const debounce = (func, delay) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};

export function toggleInert(elements, shouldBeInert) {
  elements.forEach((el) => {
    if (el) {
      if (shouldBeInert) {
        el.setAttribute('inert', '');
      } else {
        el.removeAttribute('inert');
      }
    }
  });
}